import { useState } from "react";
import { useTranslation } from "react-i18next";
import authenticationService from "@src/services/authentication.service";
import PageTitle from "@src/components/PageTitle";
import {
  withSnackbar,
  WithSnackbarProps,
} from "@src/components/SnackBarComponent";
import { useClientsQuery } from "@src/queries/clients";
import ClientsList from "./ClientPage/ClientsList";

const columns = [
  { id: "Common.UserNumber", minWidth: 100 },
  { id: "Common.LastName", minWidth: 170 },
  { id: "Common.FirstName", minWidth: 170 },
  { id: "Common.Email", minWidth: 100 },
  { id: "Common.Actions", minWidth: 65, maxWidth: 65 },
  { id: "", minWidth: 70 },
];
const AllClientsView: React.FC<WithSnackbarProps> = ({
  snackbarShowMessage,
}) => {
  const [page, setPage] = useState(0);
  const [search, setSearch] = useState("");
  const { t } = useTranslation();
  const { data, isFetching, refetch } = useClientsQuery({
    page,
    search,
  });

  const { isManagerOrAdminOrHost, isSupport } = authenticationService;
  return (
    <>
      <PageTitle title={t("Clients.Pagetitle")} />
      <ClientsList
        data={data}
        isFetching={isFetching}
        refetchData={refetch}
        page={page}
        setPage={setPage}
        setSearch={setSearch}
        columns={columns}
        snackbarShowMessage={snackbarShowMessage}
        showClientDetails={isManagerOrAdminOrHost()}
        ableToAddClient={isManagerOrAdminOrHost()}
        ableToInitiateChat={isManagerOrAdminOrHost()}
        ableToAnonymizeClient={isSupport()}
        ableToUnlockUser={isSupport()}
        ableToRemove2FA={isSupport()}
        showActionsColumn
      />
    </>
  );
};

export default withSnackbar(AllClientsView);
